import React from 'react';

import { Box, Skeleton } from '@mui/material';

import styles from './Loading.module.scss';

interface LoadingProps {
  rows?: number;
}

export const Loading: React.FC<LoadingProps> = ({ rows = 5 }) => (
  <Box className={styles.loadingRoot}>
    <Box className={styles.loadingStack}>
      <Skeleton className={styles.loadingSkeletonHeader} />
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} className={styles.loadingSkeletonRow} />
      ))}
    </Box>
  </Box>
);
